export default {
  LIST: {
    TITLE: `Liste des absences`
  },
  CREATE: `Créer une absence`,
  IN_PROGRESS: `En cours`,
  ACKNOWLEDGE: `Reçu`,
  ACKNOWLEDGED: `Reçue`,
  JUSTIFIED: `Justifiée`,
  UNJUSTIFIED: `Non justifiée`,
  REFUSED: `Refusée`,
  CANCELLED: `Annulée`,
  IN_PROGRESS_MARKED: `Mis en cours`,
  ACKNOWLEDGED_MARKED: `Reçue`,
  JUSTIFIED_MARKED: `Justifiée`,
  UNJUSTIFIED_MARKED: `Non justifiée`,
  REFUSED_MARKED: `Refusée`,
  CANCELLED_MARKED: `Annulée`,
  STATUS: `Statut`,
  MANAGEMENT: `Gestion`,
  TIME_PAID: `Heures payées`,
  CREATION_DATE: `Crée le`,
  LAST_MODIFIED_DATE: `Modifié le`,
  FIRST_COLUMN: ``,
  SECOND_COLUMN: ``,
  OVER_THRESHOLD: `au-dessus du seuil`,
  CREATED_BY_ON: `Créé par <0>{{createdBy}}</0> le {{date}} <2>{{time}}</2>`,
  STATUS_PHRASE: `<0>{{status}}</0> par <1>{{validateBy}}</1> le {{date}} <3>{{time}}</3>`,
  COMMENT: `<0>{{count}} commentaire <2/></0>`,
  COMMENT_other: `<0>{{count}} commentaires <2/></0>`,
  REASON_INFO: `Raison`,
  MADE_BY_PHONE: `Envoyé par téléphone: {{phone}}`,
  ABSENCE: `Absence`,
  LATENESS: `Retard, arrive à {{ time }}`,
  EARLYOUT: `Départ hâtif, part à {{ time }}`,
  TRANSFERED_INTO_INTEGRATION: `Transferé dans l'intégration`,
  TRANSFER_INTO_INTEGRATION_FAILED: `Non transferé dans l'intégration`,
  DELETE: {
    TITLE: `Supprimer la requête d'absence`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer la requête d'absence?`,
    PRIMARY_ACTION: `Supprimer la requête`
  },
  csv: {
    ATTENDANCE_CSV_NAME: `presence_export_{{date}}`,
    REQUEST_DATE: `Date de requête`,
    CREATED_BY: `Créé par`,
    VALIDATION_DATE: `Date de validation`,
    VALIDATED_BY: `Validé par`,
    REQUEST_TYPE: `Type de requête`,
    COMMENTS: `Commentaires`,
    REASON: `Raison`,
    DATE: `Date`,
    START: `Début`,
    END: `Fin`,
    ARRIVAL_TIME: `Heure d'arrivée`,
    DEPARTURE_TIME: `Heure de départ`,
    REQUEST_STATUS: `Statut de la requête`,
    DEPARTMENTS: `Départements`,
    TEAMS: `Équipes`,
    PROJECT: `Projet`,
    EMPLOYEE_NUMBER: `Numéro d'employé`,
    EMPLOYEE: `Employé`,
    ARCHIVED: `Archivé`,
    STATUS: `Statut`
  },
  TOTAL_ABSENCES_IN_BANK: `L'employé a demandé {{ totalAbsences }} absence(s) au cours des {{ period }} derniers jours.`,
  TOTAL_ABSENCES_IN_BANK_MY_HOME: `Tu as demandé {{ totalAbsences }} absence(s) au cours des {{ period }} derniers jours.`,
  ABSENCE_OVER_THRESHOLD: `Absence au-dessus du seuil`,
  THIS_ABSENCE_WILL_BE_OVER_THRESHOLD: `Cette absence dépassera le seuil maximum permis.`,
  form: {
    CREATE: {
      TITLE: `Créer une requête d'absence`
    },
    EDIT: { TITLE: `Modifier la requête d'absence` },
    DATE: {
      LABEL: `Date`
    },
    EVENTID: {
      LABEL: `Quart de travail`,
      DESCRIPTION: `Sélectionner le quart de travail pour lequel vous souhaitez créer une requête.`,
      EMPTY_PLACEHOLDER: `Veuillez sélectionner un employé. Si un employé est sélectionné, il n'y a aucun quart pour lequel créer une requête.`
    },
    REQUESTTYPEID: {
      LABEL: `Type de requête`,
      DESCRIPTION: ``
    },
    REASONID: {
      LABEL: `Raison`,
      DESCRIPTION: ``
    },
    COMMENT: {
      LABEL: `Commentaire`,
      PLACEHOLDER: `Écrivez un commentaire`,
      DESCRIPTION: ``
    },
    ARRIVALTIME: {
      LABEL: `Heure d'arrivée`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DEPARTURETIME: {
      LABEL: `Heure de départ`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    USERID: {
      LABEL: `Employé`,
      DESCRIPTION: ``
    },
    REQUESTSTATUSID: {
      LABEL: `Statut`,
      DESCRIPTION: ``
    },
    NOT_LINKED_TO_SHIFT: `Aucun quart de travail à la date sélectionnée`,
    USER_REQUIRED: `Veuillez selectionner un employé.`,
    COMMENT_REQUIRED: `Un commentaire est requis.`,
    SHIFT_REQUIRED: `Veuillez sélectionner un quart de travail.`,
    REQUEST_TYPE_ID_REQUIRED: `Veuillez sélectionner un type de requête.`,
    REASON_ID_REQUIRED: `Veuillez sélectionner une raison.`,
    ABSENCE: `Absence`,
    DELAY: `Retard`,
    EARLY_OUT: `Départ hâtif`,
    SUBMIT: `Soumettre`,
    QUIT_PAGE: `Les modifications apportées n'ont pas été sauvegardées. Souhaitez vous quitter quand même?`,
    CANT_EDIT_INTRO: `La modification de cette requête n'est pas possible car :`,
    CANT_EDIT_EXPIRED: `le quart de travail ou le jour pour lequel elle a été créée a déjà commencé`,
    CANT_EDIT_INVALID_STATUS: `son statut est passé à `,
    AND: `et`,
    INVALID_SHIFT_SELECTION: `Vous ne pouvez pas créer une requête sur le quart selectionné à partir de votre horaire.`,
    NO_SHIFT_SELECTED: `Aucun quart sélectionné, veuillez sélectionner un quart.`
  }
}
